/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleIcon20Regular = forwardRef('MoneyCurrencyRubleIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 11.75H7.75v1.5H12a.75.75 0 1 1 0 1.5H7.75V17a.75.75 0 0 1-1.5 0v-2.25h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5V3.5c0-.69.56-1.25 1.25-1.25H12a4.75 4.75 0 1 1 0 9.5Zm-4.25-1.5v-6.5H12a3.25 3.25 0 0 1 0 6.5H7.75Z" })));
});
